module.exports = __webpack_public_path__ + "static/media/bridges.c144c533.jpg";